import { render } from "./SupplierUpdate.vue?vue&type=template&id=31299798"
import script from "./SupplierUpdate.vue?vue&type=script&lang=js"
export * from "./SupplierUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__